import { render, staticRenderFns } from "./VideoMenu.vue?vue&type=template&id=647abb40"
import script from "./VideoMenu.vue?vue&type=script&lang=js"
export * from "./VideoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3338226073/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647abb40')) {
      api.createRecord('647abb40', component.options)
    } else {
      api.reload('647abb40', component.options)
    }
    module.hot.accept("./VideoMenu.vue?vue&type=template&id=647abb40", function () {
      api.rerender('647abb40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/VideoMenu.vue"
export default component.exports